module.exports = __webpack_public_path__ + "img/issue-icon2.32ebdf6.png";